
export const environment = {
  production: true,
  apiUrl : "https://dev-services.boombinere.com/api",
  apiPaymentUrl: "https://dev-services.boombinere.com",
  websiteUrl:"https://dev-members.boombinere.com/app/#",
  paypalEndPoint: "https://www.sandbox.paypal.com/cgi-bin/webscr",
  paypalBusinessAccount:"sb-xo43ot25495@business.example.com",
  boombSecret:"OkbTW5A:P~=2EqZGb7!d2V+1>=j^{j;9ogDW'zd1X|E~iFt]Gw*7iNib0{w'-uH",
  authorizeNetEndPoint:"https://test.authorize.net/payment/payment",
  cloudfront:'https://dom04fvzkrss7.cloudfront.net/'
};

